import React from "react";

/** Opis działania i dostępnych możliwości pochodzi z katalogu backendu. */
export default function PluginDetails({ plugin }) {
  return (
    <div className="premium-plugin-details">
      <div>
        <h3>Dla jakich dokumentów</h3>
        <p>{plugin.info?.audience}</p>
        {plugin.info?.highlights?.length > 0 && (
          <ul>
            {plugin.info.highlights.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        )}
      </div>
      <div>
        <h3>Dokumenty do przesłania</h3>
        <p>{plugin.requirements.hint}</p>
        {plugin.dictionaries.length > 0 && (
          <>
            <h3>Dostępne słowniki</h3>
            <ul className="premium-plugin-tags">
              {plugin.dictionaries.map((item) => (
                <li key={item.kind}>{item.label}</li>
              ))}
            </ul>
            <p className="small text-muted">
              Możesz je włączyć w opcjach poniżej.
            </p>
          </>
        )}
      </div>
    </div>
  );
}
